/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reverseDelegateTransfer} from '../api'

export const useMutationReverseDelegateTransfer = createReactQueryMutationHook('reverseDelegateTransfer', reverseDelegateTransfer)
